import type { SERVICE, ServiceType } from '@musinsa/packages-device-detection';
import { checkRegistrationService } from '@musinsa/services-curator';
import { redirect } from 'next/navigation';

interface EntryPageProps {
  cookieHeader: string;
  xPlatform: Exclude<ServiceType, typeof SERVICE.UNKNOWN>;
}

export const EntryPage = async ({ cookieHeader, xPlatform }: EntryPageProps) => {
  const result = await checkRegistrationService({ cookieHeader, xPlatform });
  redirect(result.redirectPath);
};
